<script setup lang="ts">
import { Book, Heart, HelpCircle, Map } from "@iconoir/vue";

defineProps<{
  canvassId: string;
}>();
</script>

<template>
  <nav class="canvass-bottom-nav" aria-label="Canvass-Navigation">
    <ul role="list">
      <li>
        <RouterLink
          :to="{ name: 'canvassFlowOverview', params: { canvassId } }"
        >
          <Heart /><span>Übersicht</span>
        </RouterLink>
      </li>
      <li>
        <RouterLink :to="{ name: 'canvassFlowArea', params: { canvassId } }">
          <Map /><span>Karte</span>
        </RouterLink>
      </li>
      <li>
        <RouterLink
          :to="{ name: 'canvassFlowConversationGuide', params: { canvassId } }"
        >
          <Book /><span>Leitfaden</span>
        </RouterLink>
      </li>
      <li>
        <RouterLink :to="{ name: 'canvassFlowSupport', params: { canvassId } }">
          <HelpCircle /><span>Helpdesk</span>
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>

<style scoped>
.canvass-bottom-nav {
  flex-shrink: 0;
  background-color: var(--bg-color-tabnav);

  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    block-size: var(--canvass-flow-bottom-nav-height);
  }

  li {
    flex: 1 1 0px;
    padding-inline: var(--spacing-sm);
  }

  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    block-size: 100%;
    text-decoration: none;
    color: var(--text-color-muted);
    font-size: var(--font-size-md);
    border-top: var(--border-width-xxl) solid transparent;

    &.router-link-exact-active {
      color: var(--color-primary);
      border-color: var(--color-primary);
    }
  }
}
</style>
